module.exports = __webpack_public_path__ + "static/media/chair_seat.e7ee264c.svg";